import  useDate from './useDate';
export default useDate
